import angular from 'angular'
import controller from './manageJobs.controller.js'
import roster from './roster.html'
import template from './manageJobs.html'
import templateV3 from './manage-jobs-v3.html'
import controllerV3 from './manage-jobs-v3.controller.js'
import terminalController from '../roster/roster.ctrl'
import terminal from '../roster/roster.html'
import './manageJobs.css'

import mainMenu from '../../shared/menu/menu.html'
import menu from './menu.html'

export default angular.module('manageJobs', ['ui.router'])
  .filter('replace', function () {
    return function (input) {
      return input.replace(/\*\*(.*?)\*\*/gm, '$1')
    }
  })
  .directive('roster', function () {
    return {
      restrict: 'E',
      template: roster,
      controller: ['$scope', function ($scope) {
        this.getStatus = function (worker) {
          const classStr = $scope.isDirectHire ? 'direct-hire ' : ''

          if (worker.confirm === 2) {
            return classStr + 'confirm'
          }

          if (worker.confirm_waitlist === 2) {
            return classStr + 'confirm-waitlist'
          }

          if (worker.confirm === 1 || worker.confirm_waitlist === 1) {
            return classStr + 'off-waitlist'
          }

          return classStr
        }
      }],
      controllerAs: 'c',
      scope: {
        list: '=',
        ctrl: '=',
        isDirectHire: '='
      }
    }
  })
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.manageJobs', {
      url: '/managejobs?region&manager&week&jobId',
      resolve: {
        admins: (Companies) => {
          'ngInject'

          return Companies.fetchAdminsMJ()
        },
        jobTypes: (Jobs) => {
          'ngInject'

          return Jobs.getJobTypes()
        },
        skills: (Users) => {
          'ngInject'
          return Users.getSkills()
        }
      },
      views: {
        content: {
          controller: controller,
          controllerAs: 'mj',
          template: template
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
    $stateProvider.state('app.mj', {
      url: '/mj?region&manager&week&jobId',
      resolve: {
        admins: (Companies) => {
          'ngInject'

          return Companies.fetchAdminsMJ()
        },
        jobTypes: (Jobs) => {
          'ngInject'

          return Jobs.getJobTypes()
        },
        skills: (Users) => {
          'ngInject'
          return Users.getSkills()
        }
      },
      views: {
        content: {
          controller: controllerV3,
          controllerAs: 'mj',
          template: templateV3
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
    $stateProvider.state('app.manageJobs.roster', {
      url: '/manageJobs/:date?tab',
      params: {
        date: { squash: true, dynamic: true, value: null }
      },
      resolve: {
        myWorkforce: function (Users, $mdDialog, $state) {
          'ngInject'

          return Users.getWorkforce()
            .catch((err) => {
              console.log(err)
              $mdDialog.show(
                $mdDialog.alert()
                  .parent(angular.element(document.querySelector('body')))
                  .clickOutsideToClose(true)
                  .title('Server Error')
                  .textContent('There was an error fetching your workforce. Please try again later.')
                  .ariaLabel('Server Error')
                  .ok('OK')
              ).then($state.go('login'))
            })
        },
        myCrews: (Crews) => {
          'ngInject'

          return Crews.getCrews()
        },
        company: (Companies) => {
          'ngInject'
          return Companies.getCompanyData()
        }
      },
      views: {
        content: {
          controller: terminalController,
          controllerAs: 't',
          template: terminal
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
  })
